import React, {Component} from 'react';
import {Grid, Col, Row, Button, FormControl} from 'react-bootstrap';


import Select   from 'react-select'
 import {ADD_SELECTED_PRODUCTS, CLEAR_SELECTED_PRODUCTS} from 'actions/actionTypes';
 import config from  '../../../config';
import {prepareSelectOptionsList} from 'util/Utils';



export default class SellerServiceSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
              filterOptions: {
                  perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                  Type: _.isUndefined(this.props.location.query.Type) ? '' : this.props.location.query.Type,
                  Deleted:_.isUndefined(this.props.location.query.Deleted) ? 'false' : this.props.location.query.Deleted,

              }
        };

     };

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }

    getSearchParams(filtersChanged = {}) {
         var filterOptions = {...this.state.filterOptions, ...filtersChanged};
         console.log('filterOptions',filterOptions );
        var queryParams = {};
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if (filterOptions.Type) {
            queryParams.Type = filterOptions.Type;
        }

        if (filterOptions.Deleted  ) {
            queryParams.Deleted = filterOptions.Deleted;
        }
         return {queryParams}

    }


    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }



    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    render() {
        var self = this;
         return (
            <div className="product-search-block">
                <Row  >

                    <Col md={3} xs={6} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>


                    {/*<Col md={3} xs={3} className="top10">*/}
                        {/*<Select*/}
                            {/*tabIndex="0"*/}
                            {/*placeholder="Per Page"*/}
                            {/*clearable={false}*/}
                            {/*options={config.perPageSelectOptions}*/}
                            {/*onChange={this.onFilterChange.bind(this)}*/}
                            {/*value={self.state.filterOptions.perPage}*/}
                        {/*/>*/}
                    {/*</Col>*/}
                    <Col md={3} xs={6} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>

                    <Col xs={6} md={3} className="top10">
                    <Select
                        tabIndex="0"
                        clearable={true}
                        placeholder="Type"
                        options={ _.map({'Dropoff':'Drop-off', 'Pickup':'Pick-up'}, function (key, value) {
                            return {value: value, label: key}
                        })}
                        onChange={(option) => {
                            this.setState({
                                'filterOptions': {
                                    ...this.state.filterOptions,
                                    Type:option ?  option.value : null,
                                }
                            }, function () {
                                this.props.search();
                            });
                        }}
                        value={self.state.filterOptions.Type}
                    />

                </Col>
                    {/*<Col xs={6} md={3} className="top10">*/}
                        {/*<Select*/}
                            {/*tabIndex="0"*/}
                            {/*clearable={true}*/}
                            {/*placeholder="Deleted"*/}
                            {/*options={[*/}
                                 {/*{value: 'true', label: 'Deleted'},*/}
                                {/*{value: 'false', label: 'Active'}]}*/}
                            {/*onChange={(option) => {*/}
                                 {/*this.setState({*/}
                                    {/*'filterOptions': {*/}
                                        {/*...this.state.filterOptions,*/}
                                        {/*Deleted:option ?  option.value : null,*/}
                                    {/*}*/}
                                {/*}, function () {*/}
                                    {/*this.props.search();*/}
                                {/*});*/}
                            {/*}}*/}
                            {/*value={this.state.filterOptions.Deleted}*/}
                        {/*/>*/}

                    {/*</Col>*/}
                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" onClick={(event) => self.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>
                    {/*<Col md={3} xs={6} className="pull-right top10">*/}
                        {/*<button className="pull-right btn btn-primary" onClick={(event) => self.props.addNewService()}*/}
                                {/*type="button">*/}
                            {/*Add*/}
                        {/*</button>*/}
                    {/*</Col>*/}
                </Row>

            </div>
        );

    }
}



